export type AccessTypeKey =
	| 'ROLES'
	| 'USERS'
	| 'UNITS'
	| 'ROLES'
	| 'AREAS'
	| 'TAGS'
	| 'LEVEL_SYSTEM'
	| 'RANKING_SYSTEM'
	| 'BLOG'
	| 'CHAT'
	| 'EDUCATION'
	| 'SHOP'
	| 'MISSIONS'
	| 'MEDIABANK'
	| 'CMS'
	| 'VIRTUAL_CURRENCY'
	| 'STATISTICS'
	| 'EVENT'
	| 'DICTIONARY'
	| 'CERTIFICATIONS'
	| 'MASTER_RUN'
	| 'COMMENTS'
	| 'FORM'
	| 'PORTAL'
	| 'ENGAGEMENT_GOAL'
	| 'EXTENGAGEOBJECT'
	| 'JOURNEY'
	| 'SUPPORT'
	| 'DASHBOARD'
	| 'SPEEDQUIZ'
	| 'COUNTDOWN'
	| 'SHADOW_USER_SIMULATION'
	| 'TASKS'
	| 'DOCUMENT'
	| 'TEMPLATES'
	| 'FLOW'
	| 'MESSAGE_CENTER'
	| 'MESSAGE_CENTER_SELECTION'
	| 'LIMITED_ACCESS_MODE'
	| 'AUTOMATION'
	| 'REPORT'
	| 'TIMEREPORT';

export type AccessTypeModule = {
	Id: number;
	Name: string;
	AccessTypeKey: string;
};

export type AccessTypeRightOption = {
	Id: number;
	Value: number;
	Name: string;
};

export enum AccessTypeRight {
	Read = 10,
	EditLimited = 15,
	Write = 20,
	WriteExtended = 30,
	Admin = 40,
}

export type AccessTypeModuleAccess = {
	AccessTypeModule: AccessTypeModule;
	AccessTypeRight: AccessTypeRight;
};
